import { Asset } from './container.models';
export class Resource {
    id: number;
    containerId: number;
    type: number;
    title: string;
    url: string;
    assetId: number;
    isDeleted: boolean;
    createdAt: Date | string;
    updatedAt: Date | string;
    asset: Asset;
    altAssetId: number;
    altAsset: Asset;
    placeHolderImageKey: string;
    linkUrl: string;
    ratingCount: number;
    ratings: Rating;
    averageRating: number;
    orderBy: number;
    profileId: number;
    className: string;
    folderId: number;
}

export class Rating {
    assets: any;
    averageRating: number;
    comment: string;
    containerId: number;
    firstName: string;
    id: number;
    lastUpdatedAt: string;
    level: number;
    profileId: number;
    profileName: string;
    resourceId: number;
    title: string;
    type: number;
}

export class RatingData {
    averageRating: number;
    containerId: number;
    ratings: Rating[];
    resourceId: number;
    title: string;
    type: number;
}
